import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 386,
	height: 384,
	viewBox: "0 0 386 384",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M190.024 0H0V250.991L133.753 384H189.339C313.605 384 386 301.441 386 186.234C386 71.027 328.358 0 189.988 0H190.024ZM178.517 288H115.97V96H175.956C244.492 96 271.401 120.324 271.401 186.234C271.401 252.144 244.492 288 178.517 288Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDLogo);
export default ForwardRef;
